<template>
  <div v-if="npc" class="person" :class="`person--${name}`" :style="`--npcwidth: ${npc.Width}px; --npcbottom: ${npc.Bottom}px;`">
    <div v-if="hasSprites" class="person__inner">
      <!-- stand (left) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.LeftStand[count - 1] ? npc.LeftStand[count - 1] : npc.LeftStand[0]"
      >
      <!-- walk (left) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.LeftWalk[count - 1] ? npc.LeftWalk[count - 1] : npc.LeftWalk[0]"
      >
      <!-- stand (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightStand[count - 1] ? npc.RightStand[count - 1] : npc.RightStand[0]"
      >
      <!-- walk (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightWalk[count - 1] ? npc.RightWalk[count - 1] : npc.RightWalk[0]"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'FriendsNpc2',

  props: {
    npcs: {
      default: () => {},
      type: [Array, Object]
    }
  },

  computed: {
    npc () {
      if (this.npcs) {
        return this.npcs
      }
      return null
    },
    hasSprites () {
      if (this.npc) {
        if (
          this.npc.LeftStand.length > 2 &&
          this.npc.LeftWalk.length > 3 &&
          this.npc.RightStand.length > 2 &&
          this.npc.RightWalk.length > 2
        ) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      name: 'npc'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

$delay: 2.5s;
$duration: 10s;
.person--npc {
  display: none;
  width: 0;
  width: var(--npcwidth);
  bottom: 58px;
  bottom: calc(81px - var(--npcbottom));
  left: 80%;
  animation: npc-move $duration linear infinite $delay;

  @include breakpointHeight(md) {
    bottom: 144px;
    bottom: calc(174px - var(--npcbottom));
  }

  @include breakpoint(sm) {
    display: block;
  }

  .person__inner {
    transform: translate3d(0, 0, 0);
    animation: npc-animate $duration steps(1) infinite $delay;

    img {
      width: var(--npcwidth);
      min-width: var(--npcwidth);
    }
  }
}
@keyframes npc-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  2.5% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  5% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  7.5% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  12.5% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  15% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  17.5% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  20% {
    transform: translate3d(calc(var(--npcwidth) * -4), 0, 0);
  }
  22.5% {
    transform: translate3d(calc(var(--npcwidth) * -5), 0, 0);
  }
  25% {
    transform: translate3d(calc(var(--npcwidth) * -6), 0, 0);
  }
  27.5% {
    transform: translate3d(calc(var(--npcwidth) * -7), 0, 0);
  }
  30% {
    transform: translate3d(0, 0, 0);
  }
  32.5% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  35% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  37.5% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  40% {
    transform: translate3d(calc(var(--npcwidth) * -12), 0, 0);
  }
  42.5% {
    transform: translate3d(calc(var(--npcwidth) * -13), 0, 0);
  }
  45% {
    transform: translate3d(calc(var(--npcwidth) * -14), 0, 0);
  }
  47.5% {
    transform: translate3d(calc(var(--npcwidth) * -15), 0, 0);
  }
  50% {
    transform: translate3d(calc(var(--npcwidth) * -12), 0, 0);
  }
  52.5% {
    transform: translate3d(calc(var(--npcwidth) * -13), 0, 0);
  }
  55% {
    transform: translate3d(calc(var(--npcwidth) * -14), 0, 0);
  }
  57.5% {
    transform: translate3d(calc(var(--npcwidth) * -15), 0, 0);
  }
  60% {
    transform: translate3d(calc(var(--npcwidth) * -8), 0, 0);
  }
  62.5% {
    transform: translate3d(calc(var(--npcwidth) * -9), 0, 0);
  }
  65% {
    transform: translate3d(calc(var(--npcwidth) * -10), 0, 0);
  }
  67.5% {
    transform: translate3d(calc(var(--npcwidth) * -11), 0, 0);
  }
  70% {
    transform: translate3d(calc(var(--npcwidth) * -8), 0, 0);
  }
  72.5% {
    transform: translate3d(calc(var(--npcwidth) * -9), 0, 0);
  }
  75% {
    transform: translate3d(calc(var(--npcwidth) * -10), 0, 0);
  }
  77.5% {
    transform: translate3d(calc(var(--npcwidth) * -11), 0, 0);
  }
  80% {
    transform: translate3d(calc(var(--npcwidth) * -4), 0, 0);
  }
  82.5% {
    transform: translate3d(calc(var(--npcwidth) * -5), 0, 0);
  }
  85% {
    transform: translate3d(calc(var(--npcwidth) * -6), 0, 0);
  }
  87.5% {
    transform: translate3d(calc(var(--npcwidth) * -7), 0, 0);
  }
  90% {
    transform: translate3d(0, 0, 0);
  }
  92.5% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  95% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  97.5% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes npc-move {
  10% {
    transform: translate3d(0px, 0, 0);
  }
  20% {
    transform: translate3d(0px, 0, 0);
  }
  30% {
    transform: translate3d(-150px, 0, 0);
  }
  40% {
    transform: translate3d(-150px, 0, 0);
  }
  50% {
    transform: translate3d(0px, 0, 0);
  }
  60% {
    transform: translate3d(150px, 0, 0);
  }
  70% {
    transform: translate3d(150px, 0, 0);
  }
  80% {
    transform: translate3d(150px, 0, 0);
  }
  90% {
    transform: translate3d(0px, 0, 0);
  }
  100% {
    transform: translate3d(0px, 0, 0);
  }
}
</style>
